import { Component, OnInit, Inject, ChangeDetectorRef } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
} from "@angular/forms";
import { ServerService } from "src/app/services/server.service";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material";
import { ClipBoardService as messageService } from "src/app/services/clipboard.service";
@Component({
  selector: "app-create-creative-job",
  templateUrl: "./create-creative-job.component.html",
  styleUrls: ["./create-creative-job.component.scss"],
})
export class CreateCreativeJobComponent implements OnInit {
  selectedPlatform = "Meta";
  creative_campaign_type_list: any;
  creative_type_list: any;
  //  links: { id: number, value: string }[] = [];
  current_link: any;
  nextId: number = 1;
  allLinks: any = [];
  creativeFiles: any[] = [];
  creativePreviewUrls: any[] = [];
  creativeJobForm: FormGroup;
  editCreativeJobForm: FormGroup;
  authToken = localStorage.getItem("token");
  creative_size_platform_list: any;
  creative_size_platform: any;
  creativeSize: any[] = [];
  allCreativeJobDetails:any
  selectedCreativeSizes: any = [];
  btnStatus = false;
  previous_creativeFiles:any;
  keywords: any = [];
  header:any;
  btnValue:any;
  constructor(
    private _serverService: ServerService,
    private dialogRef: MatDialogRef<CreateCreativeJobComponent>,
    private fb: FormBuilder,
    private clipBoardMessageService: messageService,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}
  ngOnInit() {
  // console.log(this.data)
    this.allCreativeJobDetails = this.data;
    
    this.getCommonDetails();
    if(this.data.previous_value == undefined){
      this.header = "CREATE CREATIVE JOB"
      this.btnValue = "CREATE CREATIVE JOB"
      this.setCreativeJobForm();
    }
    else{
      this.header = "EDIT CREATIVE JOB"
      this.btnValue = "SAVE"
      this.setEditCreativeJobForm();
    }
  }
  setCreativeJobForm() {
    this.creativeJobForm = this.fb.group({
      creative_name: ["", Validators.required],
      job_type: ["", Validators.required],
      job_category: ["", Validators.required],
      campaign_type: ["", Validators.required],
      creative_type: ["", Validators.required],
      priority: ["", Validators.required],
      landing_page_link: ["", Validators.required],
      keywords_ads_copies: [""],
      creative_description: ["", Validators.required],
      end_date:[""],
      // creative_size:['']
      creative_size: this.fb.array([]),
      links: this.fb.array([this.createLink()]),
    });
 
  }
  get links(): FormArray {
    return this.creativeJobForm.get("links") as FormArray;
  }
  setEditCreativeJobForm(){
    this.creativeJobForm = this.fb.group({
      creative_name: [this.data.previous_value.creative_name, Validators.required],
      job_type: [this.data.previous_value.job_type, Validators.required],
      job_category: [this.data.previous_value.job_category, Validators.required],
      campaign_type: [this.data.previous_value.campaign_type, Validators.required],
      creative_type: [this.data.previous_value.creative_type, Validators.required],
      priority: [this.data.previous_value.priority, Validators.required],
      landing_page_link: [this.data.previous_value.landing_page_link, Validators.required],
      keywords_ads_copies: [],
      creative_description: [this.data.previous_value.creative_description, Validators.required],
      // creative_size:['']
      creative_size: this.fb.array([this.data.previous_value.creative_size]),
      links: this.fb.array([]),

      end_date: [this.data.previous_value.end_at]
    });
    this.selectedPlatform = this.data.previous_value.platform;
    this.selectedCreativeSizes = this.data.previous_value.creative_size 
    ? this.data.previous_value.creative_size[0].split(',') 
    : [];
    this.filterCreativeSize();
   

    this.previous_creativeFiles = this.data.previous_value.open_files
   

    const linksArray = this.creativeJobForm.get('links') as FormArray;
    this.data.previous_value.open_file_link.forEach((link: string) => {
      linksArray.push(this.fb.group({ value: [link] }));
    });

    // keyword_for_ad_copies
    this.keywords = this.data.previous_value.keyword_for_ad_copies 
    ? this.data.previous_value.keyword_for_ad_copies.split(',') 
    : [];
   
    
  }
  createLink(): FormGroup {
    return this.fb.group({
      value: [""],
    });
  }
  editLink(): FormGroup {
    return this.fb.group({
      value: [
        ""
      ],
    });
  }
  createCheckboxes() {
    const arr = this.creative_size_platform.map(() => this.fb.control(false));
    return arr;
  }
  checkbox_creative_size(creative_size: string, event: any) {
    // console.log(event.checked)
    if (event.checked) {
      this.selectedCreativeSizes.push(creative_size);
    } else {
      const index = this.selectedCreativeSizes.indexOf(creative_size);
      if (index >= 0) {
        this.selectedCreativeSizes.splice(index, 1);
      }
    }
    // console.log(this.selectedCreativeSizes)
  }
  platformSelection(platform: any, event?: any) {
    this.changeDetectorRef.detectChanges();
    this.selectedPlatform = platform;
    // this.creativeJobForm.reset();
    this.selectedCreativeSizes = [];
    this.creative_size_platform = [];
    this.creativeJobForm.patchValue({ creative_size: [] });
    this.changeDetectorRef.detectChanges();
    this.filterCreativeSize();
    // console.log(event)
  }
  getCommonDetails() {
    this._serverService.getAllStatus(this.authToken).subscribe((data: any) => {
      // console.log(data)
      this.creative_size_platform_list = data.creative_size_platform_list;
      // this
      

      // console.log(data.creative_campaign_type_list)
      this.creative_campaign_type_list = data.creative_campaign_type_list;
      this.creative_type_list = data.creative_type_list;
      this.filterCreativeSize();
      // console.log(this.creative_type_list)

      // this.allTasksStatuses = data.campaign_task_status;
    });
  }
  get creativeSizeControls() {
    return this.creativeJobForm.get("creative_size") as FormArray;
  }
  filterCreativeSize() {
  
    if(this.creative_size_platform_list != undefined){

    
    this.creative_size_platform = this.creative_size_platform_list.filter(
      (data) => {
        return data.platform == this.selectedPlatform;
      }
    )[0].creative_size;
    let creativeSizeArray = this.creativeJobForm.get(
      "creative_size"
    ) as FormArray;
    creativeSizeArray.clear();
    if(this.data.previous_value == undefined){
    this.creative_size_platform.forEach(() => {
      creativeSizeArray.push(new FormControl(false));
    });
  }
  else{
    this.creative_size_platform.forEach(size => {
      const isChecked = this.selectedCreativeSizes.includes(size);
      creativeSizeArray.push(new FormControl(isChecked));
    });
  }
}
    // this.selectedCreativeSizes = [];
    // this.creative_size_platform = [];
    // console.log(this.creative_size_platform[0].creative_size)
    
  }
  addLink(): void {
    this.links.push(this.createLink());
  }

  removeLink(index: number): void {
    this.links.removeAt(index);
  }

  fileChanged(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
      const MAX_FILE_SIZE = 100 * 1024 * 1024; 
     
      files.forEach((file) => {
        if (file.size > MAX_FILE_SIZE) {
          // Show error message and skip this file
          this.clipBoardMessageService.showMessgeInText(
            `File "${file.name}" exceeds the maximum allowed size of 100MB.`,
            'error-snackbar'
          );
          input.value = '';
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          // console.log(file);
          // console.log(reader.result)
          this.creativeFiles.push(file);
          // console.log(this.creativeFiles)
          this.creativePreviewUrls.push(reader.result);
          // console.log(this.creativePreviewUrls);
        };
        reader.readAsDataURL(file);
      });
      input.value = '';
      // console.log(this.brochureFiles)
      // console.log(this.creativePreviewUrls);
    }
  }
  discardFile(index: number): void {
    this.creativeFiles.splice(index, 1);
    this.creativePreviewUrls.splice(index, 1);
  }
  createCreativeJob() {
    this.btnStatus = true;
    const arrayOfStrings = this.creativeJobForm.value.links
      .filter((item) => item.value.trim() !== "") // Exclude objects with blank spaces or empty strings
      .map((item) => item.value);

    const formData: FormData = new FormData();
    formData.append("job_type", this.creativeJobForm.value.job_type);
    formData.append("job_category", this.creativeJobForm.value.job_category);
    formData.append("platform", this.selectedPlatform);
    formData.append("creative_name", this.creativeJobForm.value.creative_name);
    formData.append("creative_size[]", this.selectedCreativeSizes);
    formData.append("priority", this.creativeJobForm.value.priority);
    formData.append(
      "landing_page_link",
      this.creativeJobForm.value.landing_page_link
    );
    let commaSeparatedKeyword = this.keywords.join(", ");
    formData.append("keyword_for_ad_copies", commaSeparatedKeyword);
    formData.append(
      "creative_description",
      this.creativeJobForm.value.creative_description
    );
    // formData.append('open_file_link[]',arrayOfStrings);
    formData.append("campaign_id", this.data.camapign_id);
    formData.append("campaign_type", this.creativeJobForm.value.campaign_type);
    formData.append("creative_type", this.creativeJobForm.value.creative_type);
    // campaign_type:['',Validators.required],

    // console.log("")
    formData.append("end_at",this.creativeJobForm.value.end_date);
    this.creativeFiles.forEach((file) => formData.append("open_files[]", file));
    arrayOfStrings.forEach((link) => formData.append("open_file_link[]", link));

    //  console.log(this.creativeJobForm.value.end_date)
    //  console.log(arrayOfStrings)
    //  return;
    if(this.data.previous_value == undefined){
      this._serverService
      .post("campaign_module/creative_jobs", formData, this.authToken)
      .subscribe((data) => {
        this.clipBoardMessageService.showMessgeInText(
          "Creative Job Created Successfully",
          "success-snackbar"
        );
        this.dialogRef.close(data);
      });
    }
    else{
      this._serverService
      .put("campaign_module/creative_jobs/"+this.data.previous_value.id, formData, this.authToken)
      .subscribe((data) => {
        this.clipBoardMessageService.showMessgeInText(
          "Creative Job Updated Successfully",
          "success-snackbar"
        );
        this.dialogRef.close(data);
      });
    }
   
  }
  keyword(event) {
    const inputValue = event.target.value.trim();
    if (inputValue) {
      this.keywords.push(inputValue);
      // this.creativeJobForm.
      this.creativeJobForm.get("keywords_ads_copies").setValue("");
    }
  }
  removeKeyword(index: number) {
    this.keywords.splice(index, 1);
  }
  close() {
    this.dialogRef.close();
  }
  preventDefault(event: KeyboardEvent): void {
    event.preventDefault();
  }
}
